import { OrderedMap } from 'immutable';
import { stringify } from 'query-string';
import { Observable } from 'rxjs';

import Api from '../api';

import { addMultipleAction, addAction, updateAction, removeAction } from './actions';

export type Partner = {
  address: string;
  city: string;
  id: string;
  mainPicture: string;
  name: string;
  postalCode: string;
  state: string;
  status: 'accepted';
  deedApprovalRequired?: boolean;
};

export default class PartnersApi {
  static fetchRaw({
    search = '',
    countryCode = '',
    acceptsDonations = null,
    status = ['accepted'],
    ...query
  }) {
    const response = Api.get(
      `api/partners?${stringify(
        { search, countryCode, acceptsDonations, status, ...query },
        {
          arrayFormat: 'comma',
          skipEmptyString: true,
          skipNull: true,
        }
      )}`
    );
    return response as Observable<{
      partners: Array<Partner>;
    }>;
  }

  static fetch(query) {
    return PartnersApi.fetchRaw(query)
      .map((r) => r.partners)
      .map((response) =>
        addMultipleAction(
          OrderedMap(
            response.map((partner) => [partner.id, { ...partner, searchTerm: query.search }])
          )
        )
      );
  }

  static create(partner, data = {}) {
    return Api.post(`api/partners/${partner}`, data).map((addedPartner) => addAction(addedPartner));
  }

  static update(partner, data = {}) {
    return Api.patch(`api/partners/${partner}`, data).map((updatedPartner) =>
      updateAction(updatedPartner)
    );
  }

  static delete(partner, { status } = {}) {
    return Api.delete(
      `api/partners/${partner}?${stringify(
        { status },
        {
          arrayFormat: 'comma',
          skipEmptyString: true,
          skipNull: true,
        }
      )}`
    ).map(() => removeAction(partner));
  }

  static createWithToken(partnerToken: string) {
    return Api.post('api/partners/createWithToken', { partnerToken });
  }
}
